/**
 * Bulk edit sends only the fields the user filled in (OL-138). Blank selects,
 * empty multi-selects and untouched fields are left out so the backend leaves
 * those columns alone. Yes/no selects arrive as 'yes' / 'no' and become booleans.
 */
export const buildBulkEditPayload = (values, booleanFields = []) => {
  const payload = {};
  Object.entries(values).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) return;
    if (Array.isArray(value) && value.length === 0) return;
    payload[key] = booleanFields.includes(key) ? value === 'yes' : value;
  });
  return payload;
};

/** Toast text for a bulk edit response: how many changed, and why the rest were skipped. */
export const describeBulkEditResult = ({ updated = 0, skipped = [] } = {}, noun = 'record') => {
  const title = `${updated} ${noun}${updated === 1 ? '' : 's'} updated`;
  if (!skipped.length) return { title };
  const reasons = [...new Set(skipped.map((row) => row.reason))].join(' ');
  return { title, description: `${skipped.length} skipped. ${reasons}` };
};
